import { PaymentRequests as h } from "./paymentRequests.js";
var r;
((i) => {
  function a(o) {
    return `cheerfy-saved-cards-${o}`;
  }
  i.getStoredCardKey = a;
  class s {
    constructor(t) {
      this.configuration = t, this.paymentRepository = new h.PaymentRespository(
        t.gatewayUrl,
        t.gatewayToken
      );
    }
    getStoredCards() {
      const t = i.getStoredCardKey(this.configuration.engine);
      return JSON.parse(localStorage.getItem(t) ?? "[]").filter(Boolean);
    }
    storeCard(t) {
      if (!t.externalId)
        return;
      const n = i.getStoredCardKey(this.configuration.engine);
      try {
        const e = this.getStoredCards();
        if (e.some((d) => d.externalId === t.externalId))
          return;
        localStorage.setItem(n, JSON.stringify([...e, t]));
      } catch (e) {
        console.error(e);
      }
    }
    async initialize() {
      if (this.configuration.engineConfigAdapter === void 0)
        throw new Error(`Cannot initizalie the engine "${this.configuration.engine}", engineConfigAdapter missing, please provide one or override this method.`);
      const n = await (await fetch(`${this.configuration.gatewayUrl}/api/v1/payment-method/configuration/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.configuration.gatewayToken ? {
            authorization: `Token ${this.configuration.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          token: this.configuration.paymentSessionToken,
          engine_types: [this.configuration.engine],
          location_id: this.configuration.locationId,
          email: this.configuration.payerId,
          ...this.configuration.paymentSessionToken ? {} : {
            payment_method_ids: this.getStoredCards().map((e) => e.externalId)
          },
          url: window.location.host
        })
      })).json();
      this.engineConfig = this.configuration.engineConfigAdapter.adapt(n), await this.afterInitialize(this.engineConfig);
    }
    disablePaymentMethod(t) {
      if (this.configuration.payerId === void 0)
        throw new Error("No payer id available");
      return this.paymentRepository.disablePaymentMethod({
        engineType: this.configuration.engine,
        locationId: this.configuration.locationId,
        shopId: this.configuration.shopId,
        storePaymentMethodId: t,
        payerId: this.configuration.payerId
      });
    }
    async execute(t, n) {
      if (this.configuration.cashback > 0 && !t.externalUserId)
        throw new Error("External user id is required when cashback is present");
      if (t.storePaymentMethod && this.getComputedAmount() > 0)
        throw new Error("Store payment method can only be true if the computed amount is zero");
      const e = await this.executePayment(t, n);
      return e.tokenizedCard && !this.configuration.paymentSessionToken && this.storeCard(e.tokenizedCard), e;
    }
    updateAmount(t, n, e) {
      this.configuration.amount = t, this.configuration.tip = n, this.configuration.cashback = e, this.updateEngineAmount({ amount: t, tip: n, cashback: e });
    }
    getComputedAmount() {
      return Math.max(
        0,
        this.configuration.amount + this.configuration.tip - this.configuration.cashback
      );
    }
    async destroy() {
      return Promise.resolve();
    }
    getMethod() {
      return this.configuration.method;
    }
    getEngine() {
      return this.configuration.engine;
    }
  }
  i.PaymentProcess = s;
})(r || (r = {}));
export {
  r as PaymentProcessAPI
};
//# sourceMappingURL=paymentProcess.js.map
